import { render, staticRenderFns } from "./zyInfo.vue?vue&type=template&id=5f0b70c1&scoped=true&"
import script from "./zyInfo.vue?vue&type=script&lang=js&"
export * from "./zyInfo.vue?vue&type=script&lang=js&"
import style0 from "./zyInfo.vue?vue&type=style&index=0&id=5f0b70c1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b70c1",
  null
  
)

export default component.exports